;(function ($) {
  $(() => {
    const openMode = localize.accordion_open_mode || 'first' // 'first' | 'all' | 'none'

    const $accordions = $('.js-accordion')
    if (openMode === 'first') {
      $accordions.first().addClass('active').siblings('.js-panel').show()
    } else if (openMode === 'all') {
      $accordions.addClass('active').siblings('.js-panel').show()
    }

    $accordions.click(function (e) {
      e.preventDefault()
      const $this = $(this)
      $this.toggleClass('active')
      $this.siblings('.js-panel').slideToggle()
    })
  })
})(jQuery)
